import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Indicator from "./Indicator";

const testimonials = [
  {
    name: "Priya Sharma",
    message:
      "We had such an amazing experience with 360 Baby Photography for our son Aarav’s Birthday shoot. The team handled him with so much patience and creativity. They made him laugh, played along with his little games, and captured every bit of his personality beautifully. These photos are memories we will cherish forever, and I would recommend them to every parent!",
  },
  {
    name: "Rohit & Sneha Mehta",
    message:
      "As first-time parents, we were nervous about a newborn photoshoot, but 360 Baby Photography made us feel completely at ease. The way they handled our baby girl was so gentle and professional. They had adorable props, soft fabrics, and created a calm, comforting environment for her. Every picture turned out magical, capturing those fleeting moments we will never get back. Truly a priceless experience!",
  },
  {
    name: "Aditi Nair",
    message:
      "Maternity is such a beautiful phase, and I wanted photos that truly reflect the joy and anticipation we were feeling. 360 Baby Photography not only understood my vision but also suggested creative ideas I hadn’t even thought of. They made me feel confident, comfortable, and celebrated. The final photos are a mix of dreamy elegance and real emotions – absolutely perfect!",
  },
  {
    name: "Sandeep & Pooja Verma",
    message:
      "We booked a cake smash session for our son Vivaan’s first birthday, and we couldn’t be happier with the outcome. The setup was colorful and fun, the cake was gorgeous, and the team knew exactly how to engage a one-year-old to get the cutest reactions. The entire experience felt like a little celebration, and the pictures captured every moment of joy and mess beautifully.",
  },
];

const Testimonials = () => {
  const [index, setIndex] = React.useState(0);

  const handleIndicatorClick = (i) => {
    if (i < testimonials.length) {
      setIndex(i);
    }
  };

  const handleDragEnd = (e, { offset }) => {
    if (offset.x > 50) {
      setIndex(index === 0 ? testimonials.length - 1 : index - 1);
    } else if (offset.x < -50) {
      setIndex(index === testimonials.length - 1 ? 0 : index + 1);
    }
  };

  return (
    <div className="relative flex flex-col justify-center items-center w-full xl:max-w-325 m-auto xl:py-32 lg:py-32 md:py-20 sm:py-16">
      <div className="w-full h-fit bg-isabelline overflow-hidden">
        <div className="xl:text-4xl lg:text-3xl md:text-2xl sm:text-2xl tracking-[.2em] font-cormorantGaramond uppercase text-darkLiver text-center mb-6">
          Testimonials
        </div>
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            onDragEnd={handleDragEnd}
          >
            <div className="font-cormorantGaramond italic xl:text-xl lg:text-xl md:text-xl sm:text-sm text-center text-darkLiver mb-4">
              {testimonials[index].message}
            </div>
            <div className="text-darkLiver font-medium text-xs text-center tracking-[.2em] uppercase">
              {testimonials[index].name}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
      <div className="w-full xl:space-x-1 lg:space-x-1 md:space-x-1 sm:space-x-1 flex justify-center items-center xl:mt-6 lg:mt-6 md:mt-6 sm:mt-4">
        {testimonials.map((_, idx) => (
          <Indicator
            key={idx}
            onClick={() => handleIndicatorClick(idx)}
            isActive={index === idx}
            activeColor="#4d504a"
            inActiveColor="#afafa5"
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(Testimonials);
